import { Yup, type YupTypes } from "@pharmupp/p3-front-commons"

export enum ManagementEnum {
  LGO = "lgo",
}

export const managementSchema = Yup.object({
  [ManagementEnum.LGO]: Yup.string().nullable().default(null),
})

export type ManagementFormValues = YupTypes.InferType<typeof managementSchema>
